module.exports = __webpack_public_path__ + "img/icon-letter-o.2a2cbca2.svg";